module.exports = __webpack_public_path__ + "img/Gallery_3_16.b4e484f4.jpeg";